import {
	useMyCollectiblesByPartner,
	useMyOngoingParticipationsCollectiblesByPartner
} from '@capsicum/features/digital-collectibles/shared';

export const useWalletPartnerCollectibles = (filterPartnerId: string) => {
	const {
		data: myCollectibles,
		error: collectiblesErrors,
		isLoading: isLoadingCollectibles
	} = useMyCollectiblesByPartner(filterPartnerId);

	const {
		data: ongoingParticipationCollectibles,
		error: ongoingParticipationErrors,
		isLoading: isLoadingParticipations
	} = useMyOngoingParticipationsCollectiblesByPartner(filterPartnerId);

	return {
		collectibles: [...(ongoingParticipationCollectibles || []), ...(myCollectibles || [])],
		errors: [collectiblesErrors, ongoingParticipationErrors],
		isLoading: isLoadingCollectibles || isLoadingParticipations
	};
};
